<template>
  <div class="absolute" :style="positionStyle">
    <div v-show="visible" ref="content" v-click-outside="close" :class="['select-menu', position]">
      <div class="option-wrapper rounded-md overflow-hidden">
        <button class="cursor-pointer p-3 pr-1.5 relative outline-none-important" @click="handelNote">
          笔记
        </button>
        <button class="cursor-pointer p-3 pl-1.5 relative outline-none-important" @click="handelFeedback">
          反馈
        </button>
      </div>
    </div>
    <div v-if="!!currentContent">
      <Edit
        :visible.sync="noteVisible"
        :content="currentContent"
        :isFocus="focusModel === 'note'"
        :changeTime="changeTime"
        :system="currentSystem"
        @clickNote="handlechangeFocus('note')"
        @addSuccess="$emit('addSuccess')"
      />
      <Feedback
        :visible.sync="feedbackVisible"
        :content="currentContent"
        :isFocus="focusModel === 'feedback'"
        :changeTime="changeTime"
        :system="currentSystem"
        @clickFeedback="handlechangeFocus('feedback')"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { directive as clickOutside } from './click-outside';
import Edit from './note/Edit.vue';
import Feedback from './feedback/index.vue';
import { SystemData } from '.';
@Component({
  directives: {
    clickOutside
  },
  components: {
    Edit,
    Feedback,
  }
})
export default class SelectMenu extends Vue {
  @Prop({ type: Object }) content: Content;
  @Prop({ type: Number }) messageHeight: number;
  @Prop({ type: Number }) top: number;
  @Prop({ type: Number }) left: number;
  @Prop({ type: Number }) changeDate: number;
  @Prop({ type: Object }) system: SystemData;
  visible = true;
  feedbackVisible = false;
  noteVisible = false;
  position: 'bottom' | 'top' = 'top';
  changeTime = 0;
  selectWidth = 0;

  focusModel = '';

  currentContent: Content | null = null;
  currentSystem: SystemData | null = null;

  get positionStyle() {
    // 4 before距离
    const top = this.top + (this.position === 'top' ? -4 : this.messageHeight + 4);
    const boyWidht = document.body.offsetWidth;
    const halfSelectWidth = Math.floor(this.selectWidth / 2)
    const left = this.left + halfSelectWidth > boyWidht ? boyWidht - halfSelectWidth : this.left
    return {
      top: top + 'px',
      left: left - halfSelectWidth + 'px'
    };
  }

  @Watch('top')
  @Watch('left')
  @Watch('changeDate')
  positionChange() {
    this.changeTime = new Date().getTime();
    this.initPosition();
    this.visible = true;
  }

  @Watch('feedbackVisible')
  @Watch('noteVisible')
  @Watch('currentSystem', {
    deep: true
  })
  visibleChange() {
    // 更新index和新增笔记id会将takingNotes存入学习记录，需要屏蔽
    window.storyteller.getWorld().updateAssignContent({
      $id: this.currentContent?.$id || '',
      $kind: this.currentContent?.$kind || '',
      ...{
        takingNotes: this.feedbackVisible || this.noteVisible ? this.system.utteranceIndex : -1,
        touchLoading: false
      }
    });
  }

  @Watch('currentContent', {
    deep: true
  })
  currentContentChange(content: Content, oldContent: Content) {
    if (oldContent) {
      window.storyteller.getWorld().updateAssignContent({
        $id: oldContent.$id,
        $kind: oldContent.$kind,
        ...{
          takingNotes: -1,
          touchLoading: false
        }
      });
    }
    this.visibleChange();
  }

  mounted() {
    this.$nextTick(() => {
      this.selectWidth = (this.$refs.content as HTMLDivElement).offsetWidth
    })
    this.initPosition();
  }

  initPosition() {
    this.$nextTick(() => {
      this.position = this.$el.clientHeight > this.top ? 'bottom' : 'top';
    });
  }

  close() {
    this.visible = false;
  }

  handelNote() {
    this.noteVisible = true;
    this.currentContent = { ...this.content };
    this.currentSystem = { ...this.system };
    this.close();
  }
  handelFeedback() {
    this.feedbackVisible = true;
    this.currentContent = { ...this.content };
    this.currentSystem = { ...this.system };
    this.close();
  }

  handlechangeFocus(type: string) {
    this.focusModel = type;
  }
}
</script>
<style scoped>
.select-menu {
  @apply rounded-md text-white flex justify-center items-center;
  background: #666;
  transform: translateY(-100%);
}
.bottom.select-menu {
  transform: translateY(0%);
}
.select-menu::before {
  @apply absolute bottom-0 left-1/2;
  width: 8px;
  height: 8px;
  background: #666;
  border-bottom-right-radius: 4px;
  transform: translate(-50%, 50%) rotate(45deg);
  content: '';
}
.bottom.select-menu::before {
  @apply absolute w-0 h-0 top-0 left-1/2;
  width: 8px;
  height: 8px;
  background: #666;
  border-top-left-radius: 4px;
  transform: translate(-50%, -50%) rotate(45deg);
  content: '';
}

.option-wrapper button:hover{
  color: rgba(225, 225, 225, 0.7);
}

.outline-none-important {
  outline: none !important;
}
</style>
